<template lang="pug">
  .fpui-dropdown-list(v-fp-click-outside='close', :class="className")
    .content(@click="toggle")
      .content-html.label
        slot(name="label")
      i.select-icon.fa.fa-angle-down(v-if="!show", aria-hidden="true")
      i.select-icon.fa.fa-angle-up(v-else, aria-hidden="true")
    .fp-scroll(v-if="show")
      ul.dropdown.down(ref='dropdown')
        slot(name="items")
</template>

<script>
  export default {
    props: {
      maxHeight: { type: Number, default: 200 }
    },
    data () {
      return {
        show: false,
        activeDropdown: 0
      }
    },
    methods: {
      toggle () {
        this.show = !this.show
        if (this.show) {
          this.$el.addEventListener('keydown', this.onKeydown)
          process.nextTick(() => this.$refs.search && this.$refs.search.focus())
        } else {
          this.$el.removeEventListener('keydown', this.onKeydown)
        }
      },
      close () {
        this.show = false
        this.$el.removeEventListener('keydown', this.onKeydown)
      },
      getParentWithOverflow (el) {
        if (!el) return null
        let style = window.getComputedStyle(el)
        if (style.overflow === 'auto') {
          return el
        }
        return this.getParentWithOverflow(el.parentNode)
      },
      onKeydown (e) {
        let position = this.$refs.dropdown.parentNode.scrollTop
        // Key escape
        if (e.keyCode === 27) return this.close()
        // Key up
        if (e.keyCode === 38) {
          this.$refs.dropdown.parentNode.scrollTo(0, position - 36)
        }
        // Key down
        if (e.keyCode === 40) {
          this.$refs.dropdown.parentNode.scrollTo(0, position + 36)
        }
        // Key enter
        if (e.keyCode === 13) {
          this.selectOption(this.filteredOptions[this.activeDropdown])
        }
      }
    },
    computed: {
      className () {
        let className = []
        if (this.show) className.push('is-open')
        return className.join(' ')
      }
    }
  }
</script>

<style lang="less">
@import "~@/shared/styles/_variables.less";

.fpui-dropdown-list {
  position: relative;
  cursor: pointer;
  z-index: 10;
  height: 32px;
  .fp-scroll {
    max-height: 200px;
    width: 100%;
    overflow: auto;
    min-height: 100%;
    position: absolute;
    background-color: #fff;
    border: 1px solid #ccc;
    border-top-color: #e6e6e6;
    box-shadow: 0 1px 0 rgba(0, 0, 0, .06);
  }
  .dropdown {
    padding: 0;
    margin: 0;
    width: 100%;
    list-style: none;
    z-index: 1000;
    li {
      line-height: 20px;
      padding: 8px 10px;
      cursor:pointer;
      &:hover {
        background-color: rgba(0, 126, 255, .08);
      }
      &.active {
        background-color: rgba(0, 126, 255, .08);
      }
    }
  }
  .content {
    position: relative;
    background: transparent !important;
    border-radius: 0;
    border: none;
    background: #FFF none repeat scroll 0% 0%;
    border: 1px solid @grey;
    font-size: 1em;
    font-weight: 300;
    letter-spacing: 1px;
    outline: none;
    line-height: 32px;
    padding: 0 5px;
    .content-html {
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
    }
    .select-icon {
      position: absolute;
      padding: 0 5px;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      background-color: white;
    }
  }
  &.is-open {
    z-index: 11;
    &.fpui-input-color-blue:not(.error) .content {
      border-color: @blue;
    }
    &.fpui-input-color-green:not(.error) .content {
      border-color: @green;
    }
    &.fpui-input-color-red, &.error {
      border-color: @red;
    }
    &.fpui-input-color-yellow:not(.error) .content {
      border-color: @yellow;
    }
  }
}
</style>
